// NOTE: currently does not export extended select2
// importing all on global scope
import 'vendor/select2-4.0.5.js';



// WEBPACK FOOTER //
// ./app/javascript/lib/vendor_extensions/select2_extended.js